module.exports = __webpack_public_path__ + "img/sv85on.b25271d0.svg";